module.exports = __webpack_public_path__ + "static/media/anchor.30f76d50.jpg";